import { numberFormat } from '../constants/constants';
export const trimString = str => {
  if (str !== undefined) {
    return str.toString().replace(/,/g, '');
  }
};

export const trimNumber = str => {
  if (str !== undefined) {
    let result = str.toString().replace(/,/g, '');
    return Number(result);
  }
};

export const checkPrevious = (customerInfo, selectedInsu, insurcompanyName) => {
  return (
    customerInfo.insuranceCompanyName !== undefined &&
    selectedInsu !== undefined &&
    insurcompanyName === undefined &&
    customerInfo.insuranceCompanyName === selectedInsu &&
    isCommentsValid(customerInfo)
  );
};

export const isCommentsValid = customerInfo => {
  return (
    customerInfo.appComments !== undefined &&
    customerInfo.appComments[0] !== null &&
    customerInfo.appComments[0] ===
      'Insurance Company does not meet minimum rating requirement'
  );
};

export const checkForPrevious = (customerInfo, insurcompanyName) => {
  return (
    customerInfo.insuranceCompanyName !== undefined &&
    insurcompanyName !== undefined &&
    trimString(customerInfo.insuranceCompanyName) ===
      trimString(insurcompanyName.toUpperCase()) &&
    isCommentsValid(customerInfo)
  );
};

export const getDueDate = (depositDueDate, moment) => {
  return depositDueDate !== '' &&
    depositDueDate !== undefined &&
    depositDueDate !== null
    ? moment(depositDueDate).format('MM-DD-YYYY')
    : 'Pending';
};

export const checkDiff = (
  depositAmtDiff,
  depositAmt,
  depositQuote,
  depositAmtDiff2,
) => {
  let diff;
  if (depositAmtDiff === undefined) {
    diff = depositAmtDiff;
  } else {
    diff =
      depositAmt !== undefined
        ? numberFormat(depositAmt) !== depositQuote
        : depositAmtDiff2;
  }
  return diff;
};
